import type { DomainCode } from '@australiangreens/ag-internal-components';

import { ApiBodyError } from '@/errors/ApiBodyError';
import type { SearchTemplate } from '@/types';

export const TEMPLATE_NOT_SHARED_MESSAGE =
  'This template is not shared with your state or territory.';

export function getTemplateLoadErrorMessage(err: unknown): string {
  if (err instanceof ApiBodyError) {
    const match = /^(\d{3}):/.exec(err.message);
    const code = match ? Number(match[1]) : 0;
    if (code === 403) {
      return TEMPLATE_NOT_SHARED_MESSAGE;
    }
  }
  return 'This template no longer exists or the link is incorrect.';
}

/** Whether the template is shared with the user's currently selected organisation (domain). */
export function isSearchTemplateSharedWithUserDomain(
  template: SearchTemplate,
  userDomainCode: DomainCode | undefined
): boolean {
  if (userDomainCode === undefined || userDomainCode === '') {
    return true;
  }
  return template.organisations.includes(userDomainCode);
}
